const enhanceBrxFacets = (facets) => {
    const enhancedBrxFacetResponse = facets && facets.map((facet) => {
        return {
            displayName: facet.dname,
            facetId: facet?.facetId,
            displayFacetNumbers: facet?.filterFacetCount,
            displayItems: facet?.numberOfValues
        }
    })
    return enhancedBrxFacetResponse;
}
export default enhanceBrxFacets;